// html-to-markdown.ts
import TurndownService from "turndown";
var turndownService = new TurndownService({ br: "\n" });
turndownService.addRule("h1", {
  filter: (element) => /\w+-h\d/i.test(element.nodeName),
  replacement(content, node, options) {
    const depth = +node.nodeName.replace(/\w+-h/i, "");
    return `${new Array(depth).fill(null).map(() => "#").join("")} ${content}
`;
  }
});
turndownService.addRule("text", {
  filter: (element) => /\w+-text/i.test(element.nodeName),
  replacement(content) {
    return `${content}

`;
  }
});
turndownService.addRule("link", {
  filter: (element) => /\w+-link/i.test(element.nodeName),
  replacement(content, node) {
    if (!(node instanceof HTMLElement))
      throw new Error("cant convert non-html-element to link");
    return `[${content}](${node.getAttribute("href")})
`;
  }
});
turndownService.addRule("obsidian-links", {
  filter: (element) => /\s*\[\[.*\]\]\s*/i.test(element.textContent ?? ""),
  replacement(content) {
    return `${content}`;
  }
});
function htmlToMarkdown(html) {
  return turndownService.turndown(html);
}
export {
  htmlToMarkdown
};
